import AddinCommand from '../store/schema/AddinCommand';
import ContextualAddinCommand from '../store/schema/ContextualAddinCommand';
import Control from 'owa-service/lib/contract/Control';
import DetectedEntity from 'owa-service/lib/contract/DetectedEntity';
import Extension from 'owa-service/lib/contract/Extension';
import ExtensionEvent from 'owa-service/lib/contract/ExtensionEvent';
import ExtensionEventType from 'owa-service/lib/contract/ExtensionEventType';
import Group from 'owa-service/lib/contract/Group';
import Tab from 'owa-service/lib/contract/Tab';

export default class AddinCommandFactory {
    CreateAddinCommand(
        control: Control,
        tabInfo: Tab,
        groupInfo: Group,
        extension: Extension
    ): AddinCommand {
        return new AddinCommand(control, tabInfo, groupInfo, extension);
    }

    CreateContextualAddinCommand(
        detectedEntity: DetectedEntity,
        extension: Extension
    ): ContextualAddinCommand {
        return new ContextualAddinCommand(detectedEntity, extension);
    }

    CreateEventAddinCommand(extensionEvent: ExtensionEvent, extension: Extension): AddinCommand {
        switch (extensionEvent.Type) {
            case ExtensionEventType.ItemSend:
                const control = {
                    Id: 'ItemSend',
                    Action: extensionEvent,
                };
                return new AddinCommand(control, null, null, extension);
        }

        return null;
    }
}
